import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import SignUpPage from './SignUpPage';

export const prefix = 'bm-p-signup';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: SignUpPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;

